export default __webpack_public_path__ + "static/media/newknowledge.cafeaeea.svg";